import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Check } from "lucide-react";
import Layout from "../components/Layout";
import JournalNeutralization from "../components/JournalNeutralization";
import { api } from "../lib/api";
import { JOURNAL_PROMPTS } from "../data/courseData";

export default function JournalPage() {
  const { step } = useParams();
  const stepNum = parseInt(step, 10);
  const meta = JOURNAL_PROMPTS[stepNum];
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  async function complete(payload) {
    await api.post("/journal", { step: stepNum, ...payload });
    setDone(true);
    // After breathing → straight to the 7-day reinforcement plan (Practice 5)
    setTimeout(() => navigate(`/journey/${stepNum}/daily-practice?fresh=1`), 1400);
  }

  return (
    <Layout hideNav>
      <button onClick={() => navigate(`/journey/${stepNum}`)} className="text-sm text-[#9AAEC6] flex items-center gap-1 mb-4" data-testid="back-to-step">
        <ArrowLeft size={16} /> Week {stepNum}
      </button>
      {!done ? (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="space-y-5">
          <div>
            <div className="bps-eyebrow">Guided Journal · Emotional Neutralization</div>
            <h1 className="font-display text-3xl font-light tracking-tighter mt-1">{meta.title}</h1>
            <p className="text-sm text-[#9AAEC6] mt-2">{meta.intro}</p>
          </div>
          <JournalNeutralization prompts={meta.prompts} onComplete={complete} />
        </motion.div>
      ) : (
        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }} className="text-center py-10 space-y-5" data-testid="journal-complete">
          <div className="w-16 h-16 rounded-full bg-[#10B981] mx-auto flex items-center justify-center"><Check size={28} className="text-white" /></div>
          <div>
            <div className="bps-eyebrow">Equalized</div>
            <h2 className="font-display text-3xl font-light tracking-tighter mt-2">The pattern has been seen.</h2>
            <p className="text-sm text-[#9AAEC6] mt-2 max-w-xs mx-auto">Each round of neutralization teaches your nervous system a new pattern.</p>
          </div>
          <button onClick={() => navigate(`/journey/${stepNum}/daily-practice?fresh=1`)} className="px-6 py-3 rounded-full bg-[#22D3EE] text-[#03101F] font-medium">Continue</button>
        </motion.div>
      )}
    </Layout>
  );
}
